import React from 'react';
import { Link } from 'react-router-dom';

// Desktop Register — centred card, two-column grid for the name fields.
export default function RegisterDesktop({ vm }) {
  const { form, set, busy, err, submit } = vm;
  return (
    <div className="center-screen">
      <div className="card" style={{ width: '100%', maxWidth: 460 }}>
        <div className="card-pad" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: 'var(--brand)' }}>Mehfil by Smartify</div>
          <div className="muted" style={{ marginBottom: 18, fontSize: 13 }}>Create your organiser account</div>
          <form onSubmit={submit} style={{ textAlign: 'left' }}>
            <div className="form-grid">
              <label className="field">Name
                <input type="text" value={form.name} placeholder="First name" onChange={(e) => set('name', e.target.value)} />
              </label>
              <label className="field">Surname
                <input type="text" value={form.surname} placeholder="Surname (optional)" onChange={(e) => set('surname', e.target.value)} />
              </label>
            </div>
            <label className="field">Mobile Number
              <input type="tel" maxLength={10} value={form.mobile} placeholder="10-digit mobile" onChange={(e) => set('mobile', e.target.value)} />
            </label>
            <label className="field">Organiser / Business Name
              <input type="text" value={form.organiser} placeholder="e.g. Smart Events Co" onChange={(e) => set('organiser', e.target.value)} />
            </label>
            <div className="form-grid">
              <label className="field">Password
                <input type="password" value={form.password} placeholder="Choose a password" onChange={(e) => set('password', e.target.value)} />
              </label>
              <label className="field">Confirm Password
                <input type="password" value={form.confirm} placeholder="Re-enter password" onChange={(e) => set('confirm', e.target.value)} />
              </label>
            </div>
            {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>}
            <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
              {busy ? 'Creating account…' : 'Create Account'}
            </button>
          </form>
          <div className="muted" style={{ marginTop: 14, fontSize: 13 }}>
            Already have an account? <Link to="/">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
